export type VideoKey = 'overview' | 'series' | 'fields' | 'community' | 'podcasting' | 'journal' | 'chat'
export type ExplainerVideoEntry = {id: string | null; title: string; seconds: number; poster: string}

/** Explainer videos (src/gnothi/videos), one per surface. `id` is the YouTube id, null until the upload exists; every slot renders nothing (or its fallback) while it is null. `poster` is self-hosted (web/public/videos, `npm run poster` in src/gnothi/videos) so no request reaches Google before a play press. Literals only: the prerendered splash pages import this. */
export const EXPLAINER_VIDEOS: Record<VideoKey, ExplainerVideoEntry> = {
  overview: {id: '6eLzwjhY5Q8', title: 'Gnothi overview', seconds: 145, poster: '/videos/overview.jpg'},
  series: {id: '6xBR-UxDRjI', title: 'Series', seconds: 167, poster: '/videos/series.jpg'},
  fields: {id: '10aLMzEXjVM', title: 'Fields', seconds: 182, poster: '/videos/fields.jpg'},
  community: {id: 'oelxxsfP8og', title: 'Community', seconds: 150, poster: '/videos/community.jpg'},
  podcasting: {id: 'RldlFZdtT-o', title: 'Publishing a podcast', seconds: 122, poster: '/videos/podcasting.jpg'},
  journal: {id: 'LXYKU6pfvlk', title: 'Journal', seconds: 117, poster: '/videos/journal.jpg'},
  chat: {id: '_mR6g8a6aqE', title: 'Chat', seconds: 90, poster: '/videos/chat.jpg'},
}

/** m:ss, for the duration chip and the "How it works (m:ss)" label. */
export const videoLength = (seconds: number) => {
  const s = Math.round(seconds)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

export const youtubeWatchUrl = (id: string) => `https://www.youtube.com/watch?v=${id}`
